export default __webpack_public_path__ + "static/media/2429.de889d91.png";